import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { LinkDebitCardForm } from './LinkDebitCardForm';

export const LinkDebitCard = () => {
    return (
        <>
            <Text className="w-full text-xl font-bold text-primary-10">
                <FormattedMessage
                    id="_.link_debit_card.title"
                    defaultMessage="Link your debit card"
                />
            </Text>
            <Text className="text-base font-light leading-[150%]">
                <FormattedMessage
                    id="_.link_debit_card.scheduled_repayments_text"
                    defaultMessage="Your scheduled repayments will come from this debit card."
                />
            </Text>
            <LinkDebitCardForm useSectionGridLayout={false} />
        </>
    );
};
